import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-unauthorized',
  imports: [MatButton, TranslatePipe],
  template: `
    <div class="unauthorized-container">
      <h1>{{ 'components.unauthorized.title' | translate }}</h1>
      <p>{{ 'components.unauthorized.message' | translate }}</p>
      <button mat-raised-button color="primary" (click)="logout()">
        {{ 'components.unauthorized.logout' | translate }}
      </button>
    </div>
  `,
  styles: [`
    .unauthorized-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      gap: 1rem;
      text-align: center;
      padding: 2rem;
    }
  `],
  standalone: true,
})
export class UnauthorizedComponent {
  private readonly loginService = inject(LoginService);

  logout(): void {
    this.loginService.logout();
  }
}
